module.exports = __webpack_public_path__ + "img/small_logo.8fc0ef57.svg";